import useIsStore from '@hooks/useIsStore'
import dynamic from 'next/dynamic'

const LongOrCompactCPG = dynamic(() => import('./LongOrCompactCPG'))
const Products = dynamic(() => import('./Products'))

export interface Props {
  nextOpenDate: React.ReactNode
}

export default function LongOrCompactLayout(props: Props) {
  const {nextOpenDate} = props
  const isStore = useIsStore()

  return isStore ? <LongOrCompactCPG nextOpenDate={nextOpenDate} /> : <Products />
}
